import { ReadonlyRepositoryObjectService, Result } from '@softline/core';
import { computed, inject, Injectable } from '@angular/core';
import { DefaultValuePayload } from '../types/default-value-payload';
import { DefaultValueRepository } from '../repositories/default-value.repository';
import { WeightReport } from '../types/weight-report.model';
import { DefaultValuePayloadService } from './default-value-payload.service';

@Injectable()
export class DefaultValueService extends ReadonlyRepositoryObjectService<
  WeightReport,
  Result<WeightReport>,
  DefaultValuePayload
> {
  readonly defaultValuePayloadService = inject(DefaultValuePayloadService);
  override params = computed(() => {
    return { stable: this.defaultValuePayloadService.stable() };
  });

  constructor() {
    super(inject(DefaultValueRepository));
  }

  protected override getValue(result: Result<WeightReport>): WeightReport {
    return result.result;
  }
}
